<template>
  <div class="nio-icon-tags">
    <div v-if="discountData?.discount_tip_icon" class="nio-icon-tags__tip">
      <nio-image
        :src="discountData.discount_tip_icon"
        :style="getStyle(discountData.discount_tip_icon_ratio)"
        alt="discount"
        :hideOnFail="true"
      />
    </div>
    <div
      v-for="item in displayIconList"
      :key="item.icon + (item.iconType || '')"
      class="nio-icon-tags__item"
    >
    <nio-image
        :src="item.icon"
        :style="getStyle(item.iconRatio)"
        :alt="item.iconType || 'icon'"
        :hideOnFail="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import NioImage from 'busComponent/src/baseComponents/NioImage.vue'

const ICON_HEIGHT = 18

const props = defineProps({
  iconList: {
    type: Array as PropType<
      {
        icon: string
        iconRatio?: number
        iconType?: string
      }[]
    >,
    default: () => [],
  },
  discountData: {
    type: Object as PropType<{
      discount_tip_icon: string
      discount_tip_icon_ratio?: number
    }>,
    default: undefined,
  },
})

const displayIconList = computed(() =>
  props.discountData?.discount_tip_icon ? props.iconList.slice(0, 1) : props.iconList
)

const getStyle = (ratio?: number) => {
  const r =
    typeof ratio === 'number'
      ? ratio
      : undefined
  const w = r && r > 0 ? `${r * ICON_HEIGHT}px` : 'auto'
  const h = `${ICON_HEIGHT}px`
  return { width: w, height: h }
}
</script>

<style scoped>
.nio-icon-tags {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}

.nio-icon-tags__tip {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
}

.nio-icon-tags__item {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
}


</style>